'use client'

import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid2'
import { DashboardFeaturesAdvantageBlocks } from '../DashboardFeaturesAdvantageBlocks'
import FeaturePackedDashboard from '../FeaturePackedDashboard'
import StrategyEditor from '../StrategyEditor'
import { StrategyTestColdCard } from '../StrategyTestColdCard'
import { TechnicalAnalysisColdCard } from '../TechnicalAnalysisColdCard'
import { TemplateColdCard } from '../TemplateColdCard'

// --------------------------------------------------------------------------------------------- //

export function FeaturesIndexView() {
  return (
    <>
      <FeaturePackedDashboard />
      <DashboardFeaturesAdvantageBlocks />
      <TechnicalAnalysisColdCard />
      <StrategyEditor />
      <Container maxWidth={false} sx={{ py: 5, maxWidth: '1544px' }}>
        <Grid container spacing={2}>
          <Grid
            size={{
              xs: 12,
              lg: 6
            }}
          >
            <StrategyTestColdCard />
          </Grid>
          <Grid
            size={{
              xs: 12,
              lg: 6
            }}
          >
            <TemplateColdCard />
          </Grid>
        </Grid>
      </Container>
    </>
  )
}
